import { FilterOutlined } from "@ant-design/icons";
import { useState } from "react";
import FiltrosFacturasPorCobrar from "../Components/Factura/Listar/FiltrosFacturasPorCobrar";
import {  Col, Row } from "react-bootstrap";
import { Button } from "antd";
import GridSoporteListado from "../Components/Soporte/GridSoporteListado";

function Soporte() {

    const [showFilterInvoice, setShowFilterInvoice] = useState(false);

    const handleFilter = () => {
        setShowFilterInvoice(!showFilterInvoice);
    }

    const handleCloseFilter = () => {
        setShowFilterInvoice(!showFilterInvoice);
    }

    const [filters, setFilters] = useState({});

    const updateFilters = (newFilters) => {
        setFilters(newFilters);
    };


    return (
        <div className="page-content">
            <div className="container-fluid">
                <Row className="d-flex align-items-center justify-content-between mb-3">
                    <Col>
                        <div className="page-title-box">

                            <div className="page-title-letf">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="#">Facturas Por Cobrar</a>
                                    </li>
                                    <li className="breadcrumb-item active">Listado</li>
                                </ol>
                            </div>

                        </div>
                    </Col>
                    <Col className="text-end">
                        <Button title="Filtros" icon={<FilterOutlined />} onClick={() => { (handleFilter()) }}/>

                    </Col>

                </Row>

                <Row>
                    <Col sm={12}>
                        <GridSoporteListado 
                            data={{
                                filters:filters
                            }} 
                        />
                    </Col>
                </Row>

            </div>

            <FiltrosFacturasPorCobrar
                data={{
                    show: showFilterInvoice,
                    handleClose: handleCloseFilter,
                    filters: filters, 
                    updateFilters: updateFilters,
                }}
            />

        </div>
    )

}

export default Soporte;